import type { ChargeCodesResponse } from './api';

export interface ChargeCodeOption {
  label: string;
  value: string;
}

export const normalizeChargeCodes = (list: ChargeCodesResponse): ChargeCodeOption[] => {
  if (!list) {
    return [];
  }

  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeID,
  }));
};
